import React, { useEffect, useState } from 'react';
import styles from './CapturePreview.module.css';

export function CapturePreview({
  imageBlob,
  isProcessing,
  onConfirm,
  onRetake,
  currentSide = 'front',
}) {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    const url = URL.createObjectURL(imageBlob);
    setImageUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [imageBlob]);

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img src={imageUrl} alt="Captured card" className={styles.image} />
        {isProcessing && (
          <div className={styles.loadingOverlay}>
            <div className={styles.spinner} />
            <span className={styles.loadingText}>Analyzing card...</span>
          </div>
        )}
      </div>
      <div className={styles.actions}>
        <button
          className={`${styles.btn} ${styles.btnSecondary}`}
          onClick={onRetake}
          disabled={isProcessing}
        >
          Retake
        </button>
        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          onClick={onConfirm}
          disabled={isProcessing}
        >
          {currentSide === 'front' ? 'Next: Take Back' : 'Process Card'}
        </button>
      </div>
    </div>
  );
}
